// // src/components/AmenitiesSection.js
// import React from 'react';
// import { motion } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';
// import { 
//   FaWifi, 
//   FaShieldAlt, 
//   FaParking, 
//   FaDumbbell,
//   FaUtensils,
//   FaHome,
//   FaBroom,
//   FaShoppingBag,
//   FaFilm,
//   FaMugHot,
//   FaKey,
//   FaBuilding
// } from 'react-icons/fa';

// const AmenitiesSection = () => {
//   // Intersection Observer for scroll animations
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.08,
//         delayChildren: 0.1,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: {
//         type: "spring",
//         stiffness: 80,
//         damping: 12,
//       },
//     },
//   };

//   // Updated Amenities based on new content
//   const amenities = [
//     {
//       icon: FaParking,
//       title: "Secure Covered Parking",
//       desc: "Safe basement parking within The Centaurus Mall for your convenience."
//     },
//     {
//       icon: FaWifi,
//       title: "Free High-Speed WiFi",
//       desc: "Complimentary internet access available in all apartments and common areas."
//     },
//     {
//       icon: FaHome,
//       title: "Fully Furnished Luxury Apartments",
//       desc: "Modern interiors, spacious living areas, and fully equipped kitchens designed for comfort."
//     },
//     {
//       icon: FaBroom,
//       title: "Housekeeping Service",
//       desc: "Daily cleaning service available on request for a hassle-free stay."
//     },
//     {
//       icon: FaShieldAlt,
//       title: "24/7 Security",
//       desc: "Round-the-clock building security ensuring safety and peace of mind."
//     },
//     {
//       icon: FaUtensils,
//       title: "Dining & Food Court Access",
//       desc: "Direct access to cafés, premium restaurants, and the Centaurus Food Court."
//     },
//     {
//       icon: FaDumbbell,
//       title: "Gym & Snooker",
//       desc: "Stay active with our fully equipped fitness center and snooker facilities."
//     },
//     {
//       icon: FaShoppingBag,
//       title: "Shopping & Cinema",
//       desc: "Enjoy international brands and a modern cinema experience just steps away."
//     }
//   ];

//   // Statistics
//   const stats = [
//     { number: "24/7", label: "Security", icon: "🛡️" },
//     { number: "100", label: "Mbps WiFi", icon: "📶" },
//     { number: "8+", label: "Premium Facilities", icon: "🏆" },
//     { number: "5★", label: "Service", icon: "⭐" }
//   ];

//   return (
//     <section className="py-12  relative overflow-hidden">


//       {/* Content */}
//       <motion.div 
//         ref={ref}
//         initial="hidden"
//         animate={inView ? "visible" : "hidden"}
//         variants={containerVariants}
//         className="relative z-10 container-custom"
//       >
//         {/* Section Header */}
//         <motion.div variants={itemVariants} className="text-center max-w-4xl mx-auto mb-8 space-y-2">
//           <div className="flex items-center justify-center gap-3">
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//               Live in Luxury
//             </span>
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//           </div>
          
//           <h2 className="text-4xl !mb-4 lg:text-5xl font-light text-[#1a2b3c] leading-tight">
//             Facilities at{' '}
//             <span className="font-bold text-[#c9a86c] inline-block mt-2">StayIN Centaurus</span>
//             <br />Serviced Apartments
//           </h2>
          
//           <p className="md:text-[17px] 2xl:text-lg  text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//             Everything you need for a comfortable, productive, and luxurious stay
//           </p>
//         </motion.div>


//         {/* Amenities Grid */}
//         <motion.div 
//           variants={containerVariants}
//           className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4"
//         >
//           {amenities.map((item, index) => {
//             const Icon = item.icon;
//             return (
//               <motion.div
//                 key={index}
//                 variants={itemVariants}
//                 whileHover={{ 
//                   y: -5,
//                   transition: { duration: 0.2 }
//                 }}
//                 className="group p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
//               >
//                 <div className="flex flex-col items-start">
//                   {/* Icon */}
//                   <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
//                     <Icon className="text-[#c9a86c] text-xl group-hover:text-white transition" />
//                   </div>
                  
//                   {/* Title */}
//                   <h3 className="text-md font-bold text-[#1a2b3c] mb-3">
//                     {item.title}
//                   </h3>
                  
//                   {/* Description */}
//                   <p className="2xl:text-lg text-gray-600">
//                     {item.desc}
//                   </p>
//                 </div>
//               </motion.div>
//             );
//           })}
//         </motion.div>

      
//       </motion.div>
//     </section>
//   );
// };

// export default AmenitiesSection;

// src/components/AmenitiesSection.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  FaWifi, 
  FaShieldAlt, 
  FaParking, 
  FaDumbbell,
  FaUtensils,
  FaHome,
  FaBroom,
  FaShoppingBag,
  FaFilm,
  FaMugHot,
  FaKey,
  FaBuilding
} from 'react-icons/fa';

const AmenitiesSection = () => {
  // Intersection Observer for scroll animations
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 80,
        damping: 12,
      },
    },
  };

  // Updated Amenities based on new content
  const amenities = [
    {
      icon: FaParking,
      title: "Secure Covered Parking",
      desc: "Safe basement parking within The Centaurus Mall for your convenience."
    },
    {
      icon: FaWifi,
      title: "Free High-Speed WiFi",
      desc: "Complimentary internet access available in all apartments and common areas."
    },
    {
      icon: FaHome,
      title: "Fully Furnished Luxury Apartments",
      desc: "Modern interiors, spacious living areas, and fully equipped kitchens designed for comfort."
    },
    {
      icon: FaBroom,
      title: "Housekeeping Service",
      desc: "Daily cleaning service available on request for a hassle-free stay."
    },
    {
      icon: FaShieldAlt,
      title: "24/7 Security",
      desc: "Round-the-clock building security ensuring safety and peace of mind."
    },
    {
      icon: FaUtensils,
      title: "Dining & Food Court Access",
      desc: "Direct access to cafés, premium restaurants, and the Centaurus Food Court."
    },
    {
      icon: FaDumbbell,
      title: "Gym & Snooker",
      desc: "Stay active with our fully equipped fitness center and snooker facilities."
    },
    {
      icon: FaShoppingBag,
      title: "Shopping & Cinema",
      desc: "Enjoy international brands and a modern cinema experience just steps away."
    }
  ];

  // Statistics
  const stats = [
    { number: "24/7", label: "Security", icon: "🛡️" },
    { number: "100", label: "Mbps WiFi", icon: "📶" },
    { number: "8+", label: "Premium Facilities", icon: "🏆" },
    { number: "5★", label: "Service", icon: "⭐" }
  ];

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Premium Amenities | StayIN Centaurus Serviced Apartments Islamabad</title>
        <meta name="description" content="Enjoy premium amenities at StayIN Centaurus Islamabad: free high-speed WiFi, secure parking, 24/7 security, gym, housekeeping, and direct access to dining & shopping at Centaurus Mall." />
        <meta name="keywords" content="Centaurus amenities, serviced apartments Islamabad, luxury apartments facilities, StayIN Centaurus, parking Centaurus Mall, gym Islamabad" />
      </Helmet>

      <section className="py-12 relative overflow-hidden" aria-label="Luxury amenities at StayIN Centaurus serviced apartments">
        {/* Content */}
        <motion.div 
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
          className="relative z-10 container-custom"
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="text-center max-w-4xl mx-auto mb-8 space-y-2">
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                Live in Luxury
              </span>
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
            </div>
            
            <h2 className="text-4xl !mb-4 lg:text-5xl font-light text-[#1a2b3c] leading-tight">
              Facilities at{' '}
              <span className="font-bold text-[#c9a86c] inline-block mt-2">StayIN Centaurus</span>
              <br />Serviced Apartments
            </h2>
            
            <p className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
              Everything you need for a comfortable, productive, and luxurious stay
            </p>
          </motion.div>

          {/* Amenities Grid */}
          <motion.div 
            variants={containerVariants}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4"
          >
            {amenities.map((item, index) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  whileHover={{ 
                    y: -5,
                    transition: { duration: 0.2 }
                  }}
                  className="group p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
                >
                  <div className="flex flex-col items-start">
                    {/* Icon */}
                    <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
                      <Icon className="text-[#c9a86c] text-xl group-hover:text-white transition" aria-hidden="true" />
                    </div>
                    
                    {/* Title */}
                    <h3 className="text-md font-bold text-[#1a2b3c] mb-3">
                      {item.title}
                    </h3>
                    
                    {/* Description */}
                    <p className="2xl:text-lg text-gray-600">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        </motion.div>
      </section>
    </>
  );
};

export default AmenitiesSection;